import { CompanyEntity, EMPTY_COMPANY_ENTITY } from "domain/entity/Company/CompanyEntity";
import { MasterDataType } from "domain/entity/MasterData/MasterDataEntity";
import { SearchPreferenceRepository } from "domain/repository/Common/SearchPreferenceRepo";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { MasterDataRepository } from "domain/repository/MasterData/MasterDataRepo";
import _ from "lodash";
import { CompanyEnabledSearchCriteria } from "presentation/constant/Company/CompanyEnabledSearchCriteria";
import { CompanySearchCriteria, EMPTY_COMPANY_SEARCH_CRITERIA } from "presentation/constant/Company/CompanySearchCriteria";
import { allianceCompanyValidationSchema, commonCompanyValidationSchema, masterCompanyValidationSchema } from "presentation/constant/Company/CompanyValidationSchema";
import { Validation } from "presentation/constant/Validation";

import { CompanyMaintenanceModel } from "presentation/model/Company/CompanyMaintenanceModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import BaseViewModel from "presentation/viewModel/BaseViewModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";

interface CompanyMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CompanyMaintenanceModel>> | ((value: SetStateAction<CompanyMaintenanceModel>) => void),
    ]
    companyRepo: CompanyRepository,
    searchPreferenceRepo: SearchPreferenceRepository<CompanySearchCriteria, CompanyEnabledSearchCriteria>,
    masterDataRepo: MasterDataRepository
}

export const CompanyMaintenanceVM = ({ dispatch, companyRepo, masterDataRepo }: CompanyMaintenanceVMProps) => {
    const [companyDispatch] = dispatch;

    const onShowLoading = () => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }
    const onRemoveAllSearchCriteria = () => {
        companyDispatch(prevState => {
            prevState.currentTableRef?.current?.api.setServerSideDatasource({
                getRows: (params: any) => {
                    params.success({
                        rowData: [],
                        rowCount: 0
                    })
                },
            })

            return {
                ...prevState, searchCounter: 0, searchCriteria: { ...EMPTY_COMPANY_SEARCH_CRITERIA }
            }
        })
    }

    const onSearch = async (searchCriteria: CompanySearchCriteria, isReset: boolean) => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                // companys: [],
                currentCompany: EMPTY_COMPANY_ENTITY,
                selectCompanyRows: [],
                isShowRightPanel: false,
                isAllowAutoSearch: false,
                isCompany: false,
                isCounterCompany: false,
                isAlliance: false,
                isMasterCompany: false,
                viewState: {
                    ...prevState.viewState,
                    isEditable: false,
                    isAdd: false,
                    isRead: true,
                },
            }
        })
        const companyCountAndMasterAllianceDropdown = await companyRepo.getCompanyCountAndMasterAllianceDropdown();
        let masterCompanyCount = companyCountAndMasterAllianceDropdown?.masterCompanyCount ?? 0;
        let allianceCompanyCount = companyCountAndMasterAllianceDropdown?.allianceCompanyCount ?? 0;
        let companyCount = companyCountAndMasterAllianceDropdown?.companyCount ?? 0;
        let counterCompanyCount = companyCountAndMasterAllianceDropdown?.counterCompanyCount ?? 0;
        let masterCompanyList = companyCountAndMasterAllianceDropdown?.masterCompanyList ?? [];
        let allianceCompanyList = companyCountAndMasterAllianceDropdown?.allianceCompanyList ?? [];

        let masterCompanyDropdownOptions = masterCompanyList?.map((companyStr) => {
            const [id, companyCode] = companyStr.split('-');
            return {
                dropdownLabel: companyCode || '',
                tagLabel: id || '',
                value: companyCode || '',
            };
        }) ?? [];

        let allianceCompanyDropdownOptions = allianceCompanyList?.map((companyStr) => {
            const [id, companyCode] = companyStr.split('-');
            return {
                dropdownLabel: companyCode || '',
                tagLabel: id || '',
                value: companyCode || '',
            };
        }) ?? [];

        // const companies = await companyRepo.getAllCompanies();
        // let masterCompanies = companies?.filter(company => company.companyType === 'MASTER' && company.activeInd === 'Y');
        // let allianceCompanies = companies?.filter(company => company.companyType === 'ALLIANCE' && company.activeInd === 'Y');
        // let companyCompanies = companies?.filter(company => company.companyType !== 'COUNTER_CUSTOMER' && company.companyType !== 'ALLIANCE' && company.companyType !== 'MASTER' && company.activeInd === 'Y');
        // let CounterCompanyCompanies = companies?.filter(company => company.companyType === 'COUNTER_CUSTOMER' && company.activeInd === 'Y');

        // let masterCompanyDropdownOptions = masterCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //     dropdownLabel: company.companyCode,
        //     tagLabel: company.id.toString(),
        //     value: company.companyCode,
        // })) ?? []
        // masterCompanyDropdownOptions = _.orderBy(masterCompanyDropdownOptions, "dropdownLabel");

        // let allianceCompanyDropdownOptions = allianceCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //     dropdownLabel: company.companyCode,
        //     tagLabel: company.id.toString(),
        //     value: company.companyCode,
        // })) ?? []
        // allianceCompanyDropdownOptions = _.orderBy(allianceCompanyDropdownOptions, "dropdownLabel");

        // let isCounter: boolean = false;
        let isCompany: boolean = false;
        // if (searchCriteria.customerType === 'CC') {
        //     searchCriteria = { ...searchCriteria, customerType: null }
        //     isCounter = true;
        if (searchCriteria.customerType === 'SL') {
            const slCompanyType = ['LINE', 'FORWARDER', 'AGENT', 'RAIL_OPS'];
            searchCriteria = { ...searchCriteria, customerType: null, companyType: slCompanyType }
            isCompany = true;
        }
        return await companyRepo.searchCompany(
            searchCriteria
        ).then((data) => {
            // if (isCounter) {
            //     data = data?.filter(company => company.companyType === 'COUNTER_CUSTOMER');
            // }


            companyDispatch(prevState => {
                let criteria = prevState.searchCriteria;
                return {
                    ...prevState,
                    companys: data,
                    selectCompanyRows: [],
                    searchCriteria: isReset && !isCompany ? { ...searchCriteria } : { ...criteria },
                    isAllowAutoSearch: false,
                    isCompany: isCompany,
                    isCounterCompany: false,
                    isAlliance: false,
                    isMasterCompany: false,
                    searchStatus: '',
                    isMasterCompanyCount: masterCompanyCount,
                    isAllianceCount: allianceCompanyCount,
                    isCompanyCount: companyCount,
                    isCounterCompanyCount: counterCompanyCount,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        masterCompanyDropdownOptions: masterCompanyDropdownOptions,
                        allianceCompanyDropdownOptions: allianceCompanyDropdownOptions,
                    }
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const searchCompanyByCode = async (companyCode: string) => {
        const companySearchCriteria: CompanySearchCriteria = {
            ...EMPTY_COMPANY_SEARCH_CRITERIA,
            companyCode: companyCode,
        };

        return await companyRepo.searchCompany(
            companySearchCriteria
        ).then((data) => {
            // if (isCounter) {
            //     data = data?.filter(company => company.companyType === 'COUNTER_CUSTOMER');
            // }


            companyDispatch(prevState => {
                return {
                    ...prevState,
                    currentCompany: data && data.length ? data[0] : EMPTY_COMPANY_ENTITY,
                }
            })
        }).catch((error) => {
            return [];
        })
    }


    const loadDropdownOption = async () => {
        await masterDataRepo.getMasterDataByKey(MasterDataType.COMPANY_TYPE).then(
            companyTypes => {
                const companyTypeDropdownOptions = companyTypes?.map((companyType) => ({
                    dropdownLabel: companyType.code,
                    tagLabel: companyType.code,
                    value: companyType.code,
                })) ?? []

                const companyTypeForSearchDropdownOptions = [
                    ...companyTypeDropdownOptions,
                    { dropdownLabel: 'MASTER', tagLabel: 'MASTER', value: 'MASTER' },
                    { dropdownLabel: 'ALLIANCE', tagLabel: 'ALLIANCE', value: 'ALLIANCE' }];

                companyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyTypeDropdownOptions: [
                            ...companyTypeDropdownOptions],
                        companyTypeForSearchDropdownOptions: [
                            ...companyTypeForSearchDropdownOptions],
                    }
                }))
            }
        )

        await companyRepo.getCompanyCountAndMasterAllianceDropdown().then(
            companyCountAndMasterAllianceDropdown => {
                let masterCompanyCount = companyCountAndMasterAllianceDropdown?.masterCompanyCount ?? 0;
                let allianceCompanyCount = companyCountAndMasterAllianceDropdown?.allianceCompanyCount ?? 0;
                let companyCount = companyCountAndMasterAllianceDropdown?.companyCount ?? 0;
                let counterCompanyCount = companyCountAndMasterAllianceDropdown?.counterCompanyCount ?? 0;
                let masterCompanyList = companyCountAndMasterAllianceDropdown?.masterCompanyList ?? [];
                let allianceCompanyList = companyCountAndMasterAllianceDropdown?.allianceCompanyList ?? [];

                let masterCompanyDropdownOptions = masterCompanyList?.map((companyStr) => {
                    const [id, companyCode] = companyStr.split('-');
                    return {
                        dropdownLabel: companyCode || '',
                        tagLabel: id || '',
                        value: companyCode || '',
                    };
                }) ?? [];

                let allianceCompanyDropdownOptions = allianceCompanyList?.map((companyStr) => {
                    const [id, companyCode] = companyStr.split('-');
                    return {
                        dropdownLabel: companyCode || '',
                        tagLabel: id || '',
                        value: companyCode || '',
                    };
                }) ?? [];
                companyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        masterCompanyDropdownOptions: masterCompanyDropdownOptions,
                        allianceCompanyDropdownOptions: allianceCompanyDropdownOptions,
                    },
                    isMasterCompanyCount: masterCompanyCount,
                    isAllianceCount: allianceCompanyCount,
                    isCompanyCount: companyCount,
                    isCounterCompanyCount: counterCompanyCount,
                }))
            }
        );

        // await companyRepo.getAllCompanies().then(
        //     companies => {
        //         let masterCompanies = companies?.filter(company => company.companyType === 'MASTER' && company.activeInd === 'Y');
        //         let allianceCompanies = companies?.filter(company => company.companyType === 'ALLIANCE' && company.activeInd === 'Y');
        //         let companyCompanies = companies?.filter(company => company.companyType !== 'COUNTER_CUSTOMER' && company.companyType !== 'ALLIANCE' && company.companyType !== 'MASTER' && company.activeInd === 'Y');
        //         let CounterCompanyCompanies = companies?.filter(company => company.companyType === 'COUNTER_CUSTOMER' && company.activeInd === 'Y');

        //         let masterCompanyDropdownOptions = masterCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //             dropdownLabel: company.companyCode,
        //             tagLabel: company.id.toString(),
        //             value: company.companyCode,
        //         })) ?? []
        //         masterCompanyDropdownOptions = _.orderBy(masterCompanyDropdownOptions, "dropdownLabel");

        //         let allianceCompanyDropdownOptions = allianceCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //             dropdownLabel: company.companyCode,
        //             tagLabel: company.id.toString(),
        //             value: company.companyCode,
        //         })) ?? []
        //         allianceCompanyDropdownOptions = _.orderBy(allianceCompanyDropdownOptions, "dropdownLabel");

        //         companyDispatch(prevState => ({
        //             ...prevState,
        //             dynamicOptions: {
        //                 ...prevState.dynamicOptions,
        //                 masterCompanyDropdownOptions: masterCompanyDropdownOptions,
        //                 allianceCompanyDropdownOptions: allianceCompanyDropdownOptions,
        //             },
        //             isMasterCompanyCount: masterCompanies.length,
        //             isAllianceCount: allianceCompanies.length,
        //             isCompanyCount: companyCompanies.length,
        //             isCounterCompanyCount: CounterCompanyCompanies.length,
        //         }))
        //     }
        // );

        await masterDataRepo.getMasterDataByKey(MasterDataType.COUNTRY).then(
            countryCodes => {
                const countryCodeDropdownOptions = countryCodes?.map((countryCode) => ({
                    dropdownLabel: countryCode.code,
                    tagLabel: countryCode.id.toString(),
                    value: countryCode.code,
                })) ?? []

                companyDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        countryCodeDropdownOptions: [
                            ...countryCodeDropdownOptions]
                    }
                }))
            }
        )
    }

    const onInitDefaultValue = () => {
        companyDispatch(prevState => {
            let companyType = prevState.currentCompany.id !== 0 ? prevState.currentCompany.companyType
                : (prevState.dynamicOptions.companyTypeDropdownOptions.length > 0 ? prevState.dynamicOptions.companyTypeDropdownOptions[0].value : '');
            let countryCodeId = prevState.currentCompany.id !== 0 && prevState.currentCompany.countryCodeId ? prevState.currentCompany.countryCodeId
                : (prevState.dynamicOptions.countryCodeDropdownOptions.length > 0 ? Number(prevState.dynamicOptions.countryCodeDropdownOptions[0].tagLabel) : null);
            if (prevState.isAlliance) {
                companyType = 'ALLIANCE';
                countryCodeId = null;
            }
            if (prevState.isMasterCompany) {
                companyType = 'MASTER';
            }
            return {
                ...prevState,
                currentCompany: {
                    ...prevState.currentCompany,
                    companyType: companyType,
                    countryCodeId: countryCodeId
                }
            }
        });
    }

    const onDropdownChange = (e: any, fieldName: string) => {
        companyDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: e?.value ?? (_.isEmpty(e) ?
                    (fieldName === "subChgTypeList" ? [] : '') : e),
            }
        }))
    }

    const onInputTextChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        if (fieldKey === 'companyCode') {
            val = val.toUpperCase();
        }
        return companyDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldKey]: val,
            }
        }))
    };

    const onMultipleDropdownChange = (e: any, fieldName: string) => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldName]: _.uniq(e?.map((item: DropdownProps) => item.value)),
                }
            }
        });
    };

    const onDropdownKeyChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any, dropKeyField?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        companyDispatch(prevState => {
            const masterCompanies = prevState.dynamicOptions.masterCompanyDropdownOptions;
            const allianceCompanies = prevState.dynamicOptions.allianceCompanyDropdownOptions;
            const countryCodes = prevState.dynamicOptions.countryCodeDropdownOptions;

            let dropKeyVal;
            if (dropKeyField === 'masterCompanyId' && masterCompanies && masterCompanies.length > 0) {
                const masterCompany = masterCompanies?.find(masterComp => val === masterComp.value);
                dropKeyVal = Number(masterCompany?.tagLabel) ?? null;
            } else if (dropKeyField === 'allianceCompanyId' && allianceCompanies && allianceCompanies.length > 0) {
                const allianceCompany = allianceCompanies?.find(allianceComp => val === allianceComp.value);
                dropKeyVal = Number(allianceCompany?.tagLabel) ?? null;
            } else if (dropKeyField === 'countryCodeId' && countryCodes && countryCodes.length > 0) {
                const countryCode = countryCodes?.find(countryCode => val === countryCode.value);
                dropKeyVal = Number(countryCode?.tagLabel) ?? null;
            }

            return {
                ...prevState,
                currentCompany: {
                    ...prevState.currentCompany,
                    [fieldKey]: val,
                    ...(dropKeyField && { [dropKeyField]: dropKeyVal })
                },
                viewState: {
                    ...prevState.viewState,
                    allFormState: {
                        ...prevState.viewState.allFormState,
                        [fieldKey]: "",
                    }
                }
            }
        });
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        if (fieldKey === 'companyCode') {
            val = val.toUpperCase();
        }

        companyDispatch(prevState => ({
            ...prevState,
            currentCompany: {
                ...prevState.currentCompany,
                [fieldKey]: val
            },
            viewState: {
                ...prevState.viewState,
                allFormState: {
                    ...prevState.viewState.allFormState,
                    [fieldKey]: "",
                }
            }
        }))
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        companyDispatch(prevState => ({
            ...prevState,
            currentCompany: {
                ...prevState.currentCompany,
                [fieldName]: checked ? "Y" : "N"
            }
        }))
    }

    const onSearchClick = async () => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: !prevState.isShowCriteriaPanel
            }
        });
    }

    const onAdd = () => {
        return companyDispatch(prevState => {
            // let isShowMaster = false;
            // let isShowAlliance = false;
            // if (prevState.isCompany) {
            //     isShowMaster = true;
            //     isShowAlliance = true;
            // }
            return {
                ...prevState,
                isShowRightPanel: true,
                isShowCriteriaPanel: false,
                currentCompany: EMPTY_COMPANY_ENTITY,
                selectCompanyRows: [],
                viewState: {
                    ...prevState.viewState,
                    isAdd: true,
                    isEditable: false,
                    isRead: false,
                    allFormState: {}
                },
                // isShowMaster: isShowMaster,
                // isShowAlliance: isShowAlliance,
            }
        });
    }

    const onDetail = (currCompany: CompanyEntity) => {
        let isShowMaster = false;
        let isShowAlliance = false;
        if (currCompany.companyType === 'MASTER') {
            isShowMaster = true;
        }
        if (currCompany.companyType === 'ALLIANCE') {
            isShowAlliance = true;
        }
        companyDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: true,
                currentCompany: currCompany,
                isShowMaster: isShowMaster,
                isShowAlliance: isShowAlliance,
            }
        });
    }

    const onSelectedCompanys = (selectedRows: CompanyEntity[]) => {
        let isShowMaster = false;
        let isShowAlliance = false;
        if (selectedRows.length === 1 && selectedRows[0].companyType === 'MASTER') {
            isShowMaster = true;
        }
        if (selectedRows.length === 1 && selectedRows[0].companyType === 'ALLIANCE') {
            isShowAlliance = true;
        }
        // if (selectedRows.length === 1 && selectedRows[0].companyType !== 'MASTER' && selectedRows[0].companyType !== 'ALLIANCE') {
        //     isShowMaster = true;
        //     isShowAlliance = true;
        // }
        companyDispatch(prevState => {
            return {
                ...prevState,
                selectCompanyRows: selectedRows,
                currentCompany: (selectedRows.length === 1 ? selectedRows[0] : EMPTY_COMPANY_ENTITY),
                isShowRightPanel: (selectedRows.length === 1 ? true : false),
                isShowCriteriaPanel: (selectedRows.length === 1 ? false : prevState.isShowCriteriaPanel),
                forceRefresh: !prevState.forceRefresh,
                viewState: {
                    ...prevState.viewState,
                    isEditable: false,
                    isAdd: false,
                    isRead: true,
                    allFormState: {}
                },
                isShowMaster: isShowMaster,
                isShowAlliance: isShowAlliance,
            }
        })
    }

    const onCancel = () => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                currentCompany: EMPTY_COMPANY_ENTITY,
                isShowRightPanel: false,
                viewState: {
                    ...prevState.viewState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    isSliderOpen: false,
                    allowAutoRefresh: false,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentCompany: CompanyEntity, isAdd: boolean) => {
        let valResult = null;
        switch (currentCompany.companyType) {
            case "ALLIANCE":
                valResult = await Validation(allianceCompanyValidationSchema).ValidateFormOnly(currentCompany);
                break;
            case "MASTER":
                valResult = await Validation(masterCompanyValidationSchema).ValidateFormOnly(currentCompany);
                break;
            default:
                valResult = await Validation(commonCompanyValidationSchema).ValidateFormOnly(currentCompany);
        }

        if (valResult) {
            let allValResult: { [x: string]: string } = {};


            allValResult = {
                ...allValResult, ...valResult,
                //mandatoryCheckFail: 'Please input the missing value.'
            };



            companyDispatch(prevState => {
                return {
                    ...prevState,
                    isShowRightPanel: true,
                    viewState: {
                        ...prevState.viewState,
                        allFormState: {
                            ...allValResult,
                        },

                    }
                }
            });
            return { "saveCompanyFailed": ""/*'Please input the missing value.'*/ };
        } else {
            return await (isAdd ? companyRepo.createNewCompany(currentCompany) : companyRepo.updateCompany(currentCompany)).then((data) => {
                if (data && (data.toString().startsWith("Error:") || data.toString().includes("Duplicate"))) {
                    companyDispatch(prevState => {
                        return {
                            ...prevState,
                            allFormState: { "saveCompanyFailed": data.toString() }
                        };
                    });
                    return { "saveCompanyFailed": data.toString() };
                } else {
                    if (data) {
                        return companyDispatch(prevState => {
                            return {
                                ...prevState,
                                companys: [],
                                currentCompany: EMPTY_COMPANY_ENTITY,
                                selectCompanyRows: [],
                                isShowRightPanel: false,
                                viewState: {
                                    ...prevState.viewState,
                                    isAdd: false,
                                    isRead: true,
                                    isEditable: false,
                                    isSaveClicked: false,
                                    lastEditRowId: '',
                                    isSliderOpen: false,
                                    allFormState: {}
                                }
                            }
                        })
                    }
                }
            })
        }
    }

    const onConfirm = async (selectedRows: CompanyEntity[]) => {
        return await companyRepo.confirmCompanies(selectedRows).then((data) => {
            if (data) {

            } else {
                throw new Error(data as string)
            }
            return data;
        }).catch((error) => {
            return [];
        })
    }

    const onGroupButtonClick = async (buttonId: string) => {
        companyDispatch(prevState => {
            return {
                ...prevState,
                currentCompany: EMPTY_COMPANY_ENTITY,
                selectCompanyRows: [],
                isShowRightPanel: false,
                isShowCriteriaPanel: false,
                viewState: {
                    ...prevState.viewState,
                    isEditable: false,
                    isAdd: false,
                    isRead: true,
                },
            }
        })
        const companyCountAndMasterAllianceDropdown = await companyRepo.getCompanyCountAndMasterAllianceDropdown();
        let masterCompanyCount = companyCountAndMasterAllianceDropdown?.masterCompanyCount ?? 0;
        let allianceCompanyCount = companyCountAndMasterAllianceDropdown?.allianceCompanyCount ?? 0;
        let companyCount = companyCountAndMasterAllianceDropdown?.companyCount ?? 0;
        let counterCompanyCount = companyCountAndMasterAllianceDropdown?.counterCompanyCount ?? 0;
        let masterCompanyList = companyCountAndMasterAllianceDropdown?.masterCompanyList ?? [];
        let allianceCompanyList = companyCountAndMasterAllianceDropdown?.allianceCompanyList ?? [];

        let masterCompanyDropdownOptions = masterCompanyList?.map((companyStr) => {
            const [id, companyCode] = companyStr.split('-');
            return {
                dropdownLabel: companyCode || '',
                tagLabel: id || '',
                value: companyCode || '',
            };
        }) ?? [];

        let allianceCompanyDropdownOptions = allianceCompanyList?.map((companyStr) => {
            const [id, companyCode] = companyStr.split('-');
            return {
                dropdownLabel: companyCode || '',
                tagLabel: id || '',
                value: companyCode || '',
            };
        }) ?? [];

        // const companies = await companyRepo.getAllCompanies();
        // let masterCompanies = companies?.filter(company => company.companyType === 'MASTER' && company.activeInd === 'Y');
        // let allianceCompanies = companies?.filter(company => company.companyType === 'ALLIANCE' && company.activeInd === 'Y');
        // let companyCompanies = companies?.filter(company => company.companyType !== 'COUNTER_CUSTOMER' && company.companyType !== 'ALLIANCE' && company.companyType !== 'MASTER' && company.activeInd === 'Y');
        // let CounterCompanyCompanies = companies?.filter(company => company.companyType === 'COUNTER_CUSTOMER' && company.activeInd === 'Y');

        let isCompany = false;
        let isCounterCompany = false;
        let isMasterCompany = false;
        let isAlliance = false;
        // let companyType = "";
        // let customerType = "";
        let companys: CompanyEntity[] = [];
        switch (buttonId) {
            case 'isCompany':
                isCompany = true;
                isCounterCompany = false;
                isMasterCompany = false;
                isAlliance = false;
                // customerType = "SL";
                // companys = companyCompanies;
                companys = await companyRepo.getCompanyByType(buttonId);
                break;
            case 'isCounterCompany':
                isCompany = false;
                isCounterCompany = true;
                isMasterCompany = false;
                isAlliance = false;
                // customerType = "CC";
                // companys = CounterCompanyCompanies;
                companys = await companyRepo.getCompanyByType(buttonId);
                break;
            case 'isMasterCompany':
                isCompany = false;
                isCounterCompany = false;
                isMasterCompany = true;
                isAlliance = false;
                // companyType = "MASTER";
                // companys = masterCompanies;
                companys = await companyRepo.getCompanyByType(buttonId);
                break;
            case 'isAlliance':
                isCompany = false;
                isCounterCompany = false;
                isMasterCompany = false;
                isAlliance = true;
                // companyType = "ALLIANCE";
                // companys = allianceCompanies;
                companys = await companyRepo.getCompanyByType(buttonId);
                break;
            default:
        }
        // let searchCriteria: CompanySearchCriteria = {
        //     companyType: companyType !== "" ? [companyType] : [],
        //     customerType: customerType,
        //     activeInd: 'Y',
        // }

        // let masterCompanyDropdownOptions = masterCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //     dropdownLabel: company.companyCode,
        //     tagLabel: company.id.toString(),
        //     value: company.companyCode,
        // })) ?? []
        // masterCompanyDropdownOptions = _.orderBy(masterCompanyDropdownOptions, "dropdownLabel");

        // let allianceCompanyDropdownOptions = allianceCompanies?.filter(company => company.activeInd === 'Y').map((company) => ({
        //     dropdownLabel: company.companyCode,
        //     tagLabel: company.id.toString(),
        //     value: company.companyCode,
        // })) ?? []
        // allianceCompanyDropdownOptions = _.orderBy(allianceCompanyDropdownOptions, "dropdownLabel");

        companyDispatch(prevState => {
            return {
                ...prevState,
                companys: companys,
                selectCompanyRows: [],
                isCompany: isCompany,
                isCounterCompany: isCounterCompany,
                isMasterCompany: isMasterCompany,
                isAlliance: isAlliance,
                searchStatus: buttonId,
                isMasterCompanyCount: masterCompanyCount,
                isAllianceCount: allianceCompanyCount,
                isCompanyCount: companyCount,
                isCounterCompanyCount: counterCompanyCount,
                dynamicOptions: {
                    ...prevState.dynamicOptions,
                    masterCompanyDropdownOptions: masterCompanyDropdownOptions,
                    allianceCompanyDropdownOptions: allianceCompanyDropdownOptions,
                }
            }
        })

        // await onSearch(searchCriteria, false).then((data) => {
        //     companyDispatch(prevState => {
        //         return {
        //             ...prevState,
        //             selectCompanyRows: [],
        //             isCompany: isCompany,
        //             isCounterCompany: isCounterCompany,
        //             isMasterCompany: isMasterCompany,
        //             isAlliance: isAlliance,
        //             searchStatus: buttonId,
        //             isMasterCompanyCount: masterCompanies.length,
        //             isAllianceCount: allianceCompanies.length,
        //             isCompanyCount: companyCompanies.length,
        //             isCounterCompanyCount: CounterCompanyCompanies.length,
        //         }
        //     })
        // })
    }

    const onEdit = () => {
        return companyDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: true,
                isShowCriteriaPanel: false,
                currentCompany: (prevState.selectCompanyRows.length === 1 ? prevState.selectCompanyRows[0] : EMPTY_COMPANY_ENTITY),
                viewState: {
                    ...prevState.viewState,
                    isAdd: false,
                    isEditable: true,
                    isRead: false
                }
            }
        });
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        companyDispatch(prevState => {

            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    return {
        onSearchFieldChange: onSearchFieldChange,
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onSearch,
        loadDropdownOption: loadDropdownOption,
        onDropdownChange: onDropdownChange,
        onInputTextChange: onInputTextChange,
        onSearchClick: onSearchClick,
        onAdd: onAdd,
        onDetail: onDetail,
        onSelectedCompanys: onSelectedCompanys,
        onFieldChange: onFieldChange,
        onCheckboxChange: onCheckboxChange,
        onCancel: onCancel,
        onSave: onSave,
        onInitDefaultValue: onInitDefaultValue,
        onConfirm: onConfirm,
        onDropdownKeyChange: onDropdownKeyChange,
        onGroupButtonClick: onGroupButtonClick,
        onMultipleDropdownChange: onMultipleDropdownChange,
        onEdit: onEdit,
        searchCompanyByCode: searchCompanyByCode,
    }
}